import { useUserStore } from '@/store';

function nowDate(val: any) {
  let now
  if (val) {
    now = val
  } else {
    now = new Date()
  }
  // var now = new Date();
  return `${now.getFullYear()}-${((now.getMonth() + 1) < 10 ? `0${(now.getMonth() + 1)}` : (now.getMonth() + 1))}-${(now.getDate() < 10 ? `0${now.getDate()}` : now.getDate())}`
}

export function getPath(val: any) {
  val.children.forEach((item: any) => {
    if (item.children) {
      this.getPath(item)
    }
    if (this.redirectPath == item.path) {
      this.toPath = item.path
    }
  })
}

export function getDefPath(val:any): any {
  if (val.children) {
    return getDefPath(val.children[0])
  }
    return val.path
}

function padStartConvert(n: any) {
  n = n.toString()
  return n[1] ? n : `0${n}`
}

function formatDate(num: any) {
  const now = new Date()
  const nowTime = now.getTime()
  const oneDayTime = 24 * 60 * 60 * 1000
  const ShowTime = nowTime + num * oneDayTime
  const myDate = new Date(ShowTime)
  const y = myDate.getFullYear()// 年
  const m = myDate.getMonth() + 1// 月
  const d = myDate.getDate()// 日
  return [y, m, d].map(padStartConvert).join('-')
}

//  *  日或月补0
//  * @param month
//  * @returns {string}
function doHandleMonth(month:any) {
  let m = month
  if (month.toString().length == 1) {
    m = `0${  month}`
  }
  return m
}


// 获取上个月第一天
function getLastMonthFirstDay(val:any) {
  const date = new Date()
  date.setDate(val)
  const y = date.getFullYear() // 获取年份
  let m = date.getMonth() + 1 // 获取月份
  m = m < 10 ? `0${  m}` : m // 月份补 0
  return [y, m, '01'].join('-')
}

// 获取上个月最后一天
function getLastMonthLastDay(val:any) {
  const date = new Date()
  date.setDate(val)
  const y = date.getFullYear() // 获取年份
  let m = date.getMonth() + 1 // 获取月份
  let d = new Date(y, m, 0).getDate() // 获取当月最后一日
  m = m < 10 ? `0${  m}` : m // 月份补 0
  d = d < 10 ? `0${  d}` : d // 日数补 0
  return [y, m, d].join('-')
}


let time: any = null

function debounce(fn: any, delay:any) {
  return function() {
    if (time) {
      clearTimeout(time)
    }
    time = setTimeout(() => {
      fn()
    }, delay)
  }
}

function passwordCheck(value:any, cb:any) {
  if (!value) {
    return new Promise((resolve?:any) => {
      window.setTimeout(() => {
        cb('请输入密码')
        resolve()
      }, 200)
    })
  } if (value.length < 6 || value.length > 20) {
    return new Promise((resolve?:any) => {
      window.setTimeout(() => {
        cb('密码长度在 6 到 20 个字符')
        resolve()
      }, 200)
    })
  }
  let num = 0
  // 是否包含小写字母
  if (value.match(/[a-z]/g)) {
    num += 1
  }
  // 是否包含大写字母
  if (value.match(/[A-Z]/g)) {
    num += 1
  }
  // 是否包含数字
  if (value.match(/\d/g)) {
    num += 1
  }
  // 是否包含特殊符号
  if (value.match(/[!@#$%^&*(),.?":{}|<>]/g)) {
    num += 1
  }
  if (num >= 3) {
    return new Promise((resolve?:any) => {
      window.setTimeout(() => {
        cb('')
        resolve()
      }, 200)
    })
  }
  return new Promise((resolve?:any) => {
    window.setTimeout(() => {
      cb('密码必须由小写字母、大写字母、数字、特殊符号任意三种组合')
      resolve()
    }, 200)
  })
}

function getObjName(arr:any, name:any) {
  const array:any = []
  arr.forEach((item:any) =>{
    array.push(item[name])
  })
  return array
}

function getTokenType9(){
  return useUserStore().token.type == 9
}

function getAgentLevel1(){
  return useUserStore().token.type == 9 && useUserStore().profilesUserInfo.level != 2
}

function getAgent() {
  return [11, 9].includes(useUserStore().token.type)
}

function formattedString(val:any) {
  const str = `${val  }`
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function generatePassword() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';

  // 保证至少一个字母和一个数字
  const oneLetter = letters[Math.floor(Math.random() * letters.length)];
  const oneNumber = numbers[Math.floor(Math.random() * numbers.length)];

  const allChars = letters + numbers;
  const remaining = [];

  // 还需要生成 4 个字符
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 4; i++) {
    remaining.push(allChars[Math.floor(Math.random() * allChars.length)]);
  }

  // 合并所有字符
  const passwordArray = [oneLetter, oneNumber, ...remaining];

  // 随机打乱数组）
  // eslint-disable-next-line no-plusplus
  for (let i = passwordArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
  }

  return passwordArray.join('');
}

export default {
  nowDate,
  formatDate,
  debounce,
  passwordCheck,
  getObjName,
  getTokenType9,
  getAgentLevel1,
  formattedString,
  doHandleMonth,
  getLastMonthLastDay,
  getLastMonthFirstDay,
  getAgent,
  generatePassword
}
